import React from "react";
import moment from "moment";
import Typography from "@mui/material/Typography";

const JBWDateLabel = ({ inputDate, dateFormat, local = false }) => {
  return (
    <Typography variant="label" component="label">
      {local
        ? moment.utc(inputDate).local().format(dateFormat)
        : moment.utc(inputDate).format(dateFormat)}
    </Typography>
  );
};

export default JBWDateLabel;
